import { LexoRank } from 'lexorank';

const DRAG_DROP_ALLOWED_FIELDS = ['team', 'estimationId', 'parentItem'];

export const isUpdatableFieldId = (fieldId: string): boolean =>
  DRAG_DROP_ALLOWED_FIELDS.includes(fieldId) || !Number.isNaN(Number(fieldId));

export const shouldHandleEvent = (element: HTMLElement | null): boolean => {
  let current = element;
  while (current) {
    if (current.dataset?.noDnd) {
      return false;
    }
    current = current.parentElement;
  }
  return true;
};

export const renderedDayOf = (iso: string | null | undefined): string | null =>
  iso?.split('T')[0] ?? null;

export const computeOptimisticRank = (
  previousRank: string | undefined,
  nextRank: string | undefined,
): string | undefined => {
  try {
    if (!previousRank && nextRank) return LexoRank.parse(nextRank).genPrev().toString();
    if (previousRank && !nextRank) return LexoRank.parse(previousRank).genNext().toString();
    if (previousRank && nextRank) {
      return LexoRank.parse(previousRank).between(LexoRank.parse(nextRank)).toString();
    }
  } catch {
    return undefined;
  }
  return undefined;
};
